class LineItemQuantity extends HTMLElement {
  constructor() {
    super();
  }

  get selectors() {
    return {
      cart: "cart-section",
      drawer: "cart-drawer",
      quantitySelector: {
        button: "[data-action='update-quantity']",
        input: "[data-quantity-input]"
      }
    }
  }

  get attributes() {
    return {
      lineKey: "lineKey",
      quantity: "quantity"
    }
  }

  connectedCallback() {
    this.cart = document.querySelector(this.selectors.cart) ?? document.querySelector(this.selectors.drawer);

    this.input = this.querySelector(this.selectors.quantitySelector.input);

    this.customDelegate(
      "click",
      this.selectors.quantitySelector.button,
      this.onQuantityChange.bind(this)
    );
  }

  async onQuantityChange(event) {
    event.preventDefault();

    const button = event.target.closest(this.selectors.quantitySelector.button);

    const lineKey = button.dataset[this.attributes.lineKey];
    const quantity = parseInt(button.dataset[this.attributes.quantity]);

    let canChange = true;

    if (this?.input) {
      canChange = !!(quantity <= this?.input.max && quantity >= this?.input.min);
    }

    if (!canChange) {
      return false;
    }

    await this.changeLineItemQuantity(lineKey, quantity);
  }

  async changeLineItemQuantity(lineKey, quantity) {
    document.dispatchEvent(new CustomEvent("cart:loading:start"));

    const sectionsToRender = this.cart.sectionsToRender ?? [];

    const cartData = await (await fetch(this.cart.routes.cartChange, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: sectionsToRender
      })
    })).json();

    document.dispatchEvent(new CustomEvent("cart:change", {
      detail: {
        cart: cartData
      }
    }));

    document.dispatchEvent(new CustomEvent("cart:loading:end"));
  }
}

if (!customElements.get("line-item-quantity")) {
  customElements.define("line-item-quantity", LineItemQuantity);
}
